import Typography from 'components/Typography/Typography'
import './ProjectInfo.scss'

export default function ProjectInfo() {
    return (
        <div className="projectInfo">
            <div className={'description'}>
                <Typography variant={'label'} color={'lighterPrimary'}>
                    {'O projektu'}
                </Typography>
            </div>
            <div>
                <h4>
                    <a href="https://stage-craft.cinestar.cz/assets/documents/plakat_A3_CineStar.pdf">
                        Projekt CineStar s.r.o. - Digitalizace podniku CZ.31.2.0/0.0/0.0/22_015/0005376 je
                        spolufinancován Evropskou Unií.
                    </a>
                </h4>
                <p>
                    Cílem projektu je podpořit zvyšování digitální úrovně malých a středních podniků působících na
                    českých trzích prostřednictvím podpory nákupu a zavádění pokročilých digitálních technologií, které
                    pomohou zajistit zvýšeni kapacity výroby žadatele skrze digitalizaci dat a efektivnějšího propojení
                    a řízení firemních procesů.
                </p>
                <div className="d-flex gap-1 flex-wrap">
                    <img src="/images/sponsors/NGEU.png" alt="" className="d-block img-logo" />
                    <img src="/images/sponsors/NPO.png" alt="" className="d-block img-logo" />
                    <img src="/images/sponsors/mpo-logo.jpg" alt="" className="d-block img-logo" />
                </div>
            </div>
        </div>
    )
}
